import {
  ConsultaSeguimentoPergunta08ForaAlcanceEnum,
  ConsultaSeguimentoPergunta08Model,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-08/model-consultaSeguimentoPergunta08'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { HISTORICO_MCHAT_CALCULATION_STATUS } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta08Model {
  header: MchatRfAplicacaoQueryModel
  seInteressaPor: MchatRfAplicacaoQueryModel | undefined
  respondePerguntas: MchatRfAplicacaoQueryModel | undefined
  perguntas: MchatRfAplicacaoQueryModel[]
  respondeCriancas: MchatRfAplicacaoQueryModel | undefined
  model: ConsultaSeguimentoPergunta08Model
}

export const convertAplicacaoPergunta08 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta08Model | null => {
  const header = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_08_01)
  const seInteressaPor = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_08_02)
  const respondePerguntas = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_08_03)
  const perguntas = aplicacoes.filter((aplicacao) => PERGUNTA_08_PERGUNTAS.includes(aplicacao.pergunta))
  const respondeCriancas = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_08_11)
  if (header === undefined) return null

  return {
    header,
    seInteressaPor,
    respondePerguntas,
    perguntas,
    respondeCriancas,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_08_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_08_SE_INTERESSA_POR: booleanToSimNaoEnum(seInteressaPor?.stPassou),
      PERGUNTA_08_RESPONDE_PERGUNTAS: booleanToSimNaoEnum(respondePerguntas?.stPassou),
      PERGUNTA_08_FORA_ALCANCE: convertAplicacoesToForaAlcance(perguntas),
      PERGUNTA_08_RESPONDE_CRIANCAS: booleanToSimNaoEnum(respondeCriancas?.stPassou),
    },
  }
}

const convertAplicacoesToForaAlcance = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta08ForaAlcanceEnum, ReturnType<typeof booleanToSimNaoEnum>> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta08ForaAlcanceEnum, ReturnType<typeof booleanToSimNaoEnum>>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_FORA_ALCANCE }
  )

const PERGUNTA_08_PERGUNTAS = [
  MChatPerguntaEnum.PERGUNTA_08_04,
  MChatPerguntaEnum.PERGUNTA_08_05,
  MChatPerguntaEnum.PERGUNTA_08_06,
  MChatPerguntaEnum.PERGUNTA_08_07,
  MChatPerguntaEnum.PERGUNTA_08_08,
  MChatPerguntaEnum.PERGUNTA_08_09,
  MChatPerguntaEnum.PERGUNTA_08_10,
]

const EMPTY_FORA_ALCANCE: Record<ConsultaSeguimentoPergunta08ForaAlcanceEnum, undefined> = {
  [ConsultaSeguimentoPergunta08ForaAlcanceEnum.BRINCA_COM_OUTRA_CRIANCA]: undefined,
  [ConsultaSeguimentoPergunta08ForaAlcanceEnum.FALA_COM_OUTRA_CRIANCA]: undefined,
  [ConsultaSeguimentoPergunta08ForaAlcanceEnum.BALBUCIA_FAZ_BARULHO]: undefined,
  [ConsultaSeguimentoPergunta08ForaAlcanceEnum.OLHA_PRA_OUTRA_CRIANCA]: undefined,
  [ConsultaSeguimentoPergunta08ForaAlcanceEnum.SORRI_PRA_OUTRA_CRIANCA]: undefined,
  [ConsultaSeguimentoPergunta08ForaAlcanceEnum.FICA_TIMIDO]: undefined,
  [ConsultaSeguimentoPergunta08ForaAlcanceEnum.FICA_ANIMADO]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta08ForaAlcanceEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_08_04]: ConsultaSeguimentoPergunta08ForaAlcanceEnum.BRINCA_COM_OUTRA_CRIANCA,
  [MChatPerguntaEnum.PERGUNTA_08_05]: ConsultaSeguimentoPergunta08ForaAlcanceEnum.FALA_COM_OUTRA_CRIANCA,
  [MChatPerguntaEnum.PERGUNTA_08_06]: ConsultaSeguimentoPergunta08ForaAlcanceEnum.BALBUCIA_FAZ_BARULHO,
  [MChatPerguntaEnum.PERGUNTA_08_07]: ConsultaSeguimentoPergunta08ForaAlcanceEnum.OLHA_PRA_OUTRA_CRIANCA,
  [MChatPerguntaEnum.PERGUNTA_08_08]: ConsultaSeguimentoPergunta08ForaAlcanceEnum.SORRI_PRA_OUTRA_CRIANCA,
  [MChatPerguntaEnum.PERGUNTA_08_09]: ConsultaSeguimentoPergunta08ForaAlcanceEnum.FICA_TIMIDO,
  [MChatPerguntaEnum.PERGUNTA_08_10]: ConsultaSeguimentoPergunta08ForaAlcanceEnum.FICA_ANIMADO,
}
